import React from "react";
import {Box} from "@mui/material";

export function Footer() {
  return <Box></Box>;
}
